import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Sparkles } from "lucide-react";

export default function BecomeProviderPage() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", description: "",
    contact_email: "", contact_phone: "", whatsapp: "", telegram: "", website: "", instagram: "",
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!user) return navigate("/signup", { state: { redirect: "/become-provider" } });
    setBusy(true); setError(null);
    try {
      await api.post("/providers/apply", form);
      await refresh();
      setDone(true);
    } catch (e) { setError(formatErr(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="pt-32 pb-24 px-5 md:px-10 mx-auto max-w-6xl">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="eyebrow mb-3">For providers</div>
          <h1 className="section-title text-5xl md:text-6xl mb-6">Bookings from crypto-native, lifestyle travellers.</h1>
          <p className="text-muted leading-relaxed">We bring verified clients, manage deposits, and you focus on what you do best. No monthly fees. Simple commission.</p>
          <div className="mt-10 space-y-6">
            {[
              { t: "Verified clients", d: "Every traveller goes through Meet & Mint identity checks." },
              { t: "Crypto handled for you", d: "Accept USDT/USDC clients without ever touching crypto." },
              { t: "Concierge-led traffic", d: "Curated demand from our 1M+ Meet & Mint audience." },
              { t: "Operational tools", d: "Provider dashboard, AI message drafts, payouts." },
            ].map((b) => (
              <div key={b.t}>
                <div className="font-serif-display text-2xl text-bone">{b.t}</div>
                <div className="text-sm text-muted">{b.d}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-7">
          {done ? (
            <div className="luxe-card p-10 text-center">
              <Sparkles className="mx-auto text-teal mb-3"/>
              <div className="font-script text-4xl text-bone mb-2">Application received.</div>
              <p className="text-sm text-muted">Our team will review your application and reach out within 48 hours.</p>
              <button onClick={() => navigate("/dashboard")} className="btn btn-primary mt-8" data-testid="bp-go-dashboard">Go to provider dashboard →</button>
            </div>
          ) : (
            <form onSubmit={submit} className="luxe-card p-7 space-y-4" data-testid="provider-form">
              <h2 className="font-serif-display text-3xl text-bone mb-2">Apply to provide</h2>
              <input required placeholder="Company / brand name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="input-bare" data-testid="bp-name"/>
              <textarea placeholder="Tell us about your services" value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="input-bare" data-testid="bp-desc"/>
              <div className="grid sm:grid-cols-2 gap-3">
                <input type="email" placeholder="Contact email" value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} className="input-bare" data-testid="bp-email"/>
                <input placeholder="WhatsApp / phone" value={form.contact_phone} onChange={e => setForm({...form, contact_phone: e.target.value})} className="input-bare" data-testid="bp-phone"/>
                <input placeholder="Instagram" value={form.instagram} onChange={e => setForm({...form, instagram: e.target.value})} className="input-bare"/>
                <input placeholder="Website" value={form.website} onChange={e => setForm({...form, website: e.target.value})} className="input-bare"/>
              </div>
              {error && <div className="text-rose-300 text-sm">{error}</div>}
              <button type="submit" disabled={busy} className="btn btn-primary w-full" data-testid="bp-submit">
                {busy ? "Submitting…" : (user ? "Submit application" : "Continue to sign up")}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
